const tabsInfo = {
  bloodPressure: {
    id: 'bloodPressure',
    name: 'Pressão Arterial',
    urlDescriptor: ['/Observation', '55284'],
  },
  weight: {
    id: 'weight',
    name: 'Peso',
    urlDescriptor: ['/Observation', '29463'],
  },
  height: {
    id: 'height',
    name: 'Altura',
    urlDescriptor: ['/Observation', '8302'],
  },
  diagnosis: {
    id: 'diagnosis',
    name: 'tabsInfo-patientSummary-healthSummary-tab-diagnosis',
    urlDescriptor: ['/Condition', '2.16.840.1.113883.6.3'],
  },
  problems: {
    id: 'problems',
    name: 'Problemas',
    urlDescriptor: ['/Condition', '2.16.840.1.113883.6.139'],
  },
  allergies: {
    id: 'allergies',
    name: 'tabsInfo-patientSummary-healthSummary-tab-allergies',
    urlDescriptor: ['/AllergyIntolerance'],
  },
  medications: {
    id: 'medications',
    name: 'tabsInfo-patientSummary-healthSummary-tab-medications',
    urlDescriptor: ['/MedicationRequest'],
  },
  examResults: {
    id: 'examResults',
    name: 'tabsInfo-patientSummary-healthSummary-tab-exam-results',
    urlDescriptor: ['/DocumentReference', 'ResultadoExames_FESF_V0.1'],
  },
  examRequests: {
    id: 'examRequests',
    name: 'tabsInfo-patientSummary-healthSummary-tab-exam-requests',
    urlDescriptor: ['/ServiceRequest'],
  },
  hospitalizations: {
    id: 'hospitalizations',
    name: 'tabsInfo-patientSummary-healthSummary-tab-hospitalizations',
    urlDescriptor: ['/DocumentReference', 'Sum%C3%A1rioAlta.v4.0'],
  },
  vaccines: {
    id: 'vaccines',
    name: 'Registros de Imunobiológicos',
    urlDescriptor: ['/DocumentReference', 'RegistroImunobiologico_FESF_v1.0'],
  },
  procedures: {
    id: 'procedures',
    name: 'tabsInfo-patientSummary-healthSummary-tab-procedures',
    urlDescriptor: ['/Procedure'],
  },
};

function findTabObject({ patientSummary, targetTab }) {
  try {
    const tabFound = patientSummary.entry.find((element) => {
      const elementUrl = element.resource.link[0].url;
      const foundAllUrlDescriptors = !tabsInfo[targetTab].urlDescriptor.map(
        (descriptor) => elementUrl.includes(descriptor),
      ).includes(false);
      return foundAllUrlDescriptors;
    });
    return tabFound;
  } catch (err) {
    return {};
  }
}

export { tabsInfo, findTabObject };
